import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
    faChevronLeft,
    faChevronRight,
    faSearchMinus,
    faSearchPlus,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "@ts-digital/vrc/es/components/select";
import classNames from "classnames";
import { range } from "lodash";
import getFormattedMessageWithScope from "../../../../utils/getFormattedMessageWithScope";
import "./style.css";

const fm = getFormattedMessageWithScope(
    "components.DocumentsPreviewer.Toolbar"
);

interface ToolbarProps {
    currentPage: number;
    onChangeCurrentPage: Function;
    scale: number;
    onChangeScale: Function;
    numberOfPages: number;
}

export const Toolbar = ({
    currentPage,
    onChangeCurrentPage,
    scale,
    onChangeScale,
    numberOfPages,
}: ToolbarProps) => {
    return (
        <div className="c-DocumentsPreviewer-Toolbar">
            {fm("page")}
            <Select
                className={classNames(
                    "c-DocumentsPreviewer-Toolbar-pages-select",
                    `c-DocumentsPreviewer-Toolbar-pages-select-with-${numberOfPages}-children`
                )}
                value={currentPage}
                onChange={(value: number) => onChangeCurrentPage(value)}
                options={range(numberOfPages).map((number) => ({
                    description: (number + 1).toString(),
                    value: number,
                }))}
                disabled={numberOfPages === 1}
            />
            {fm({
                id: "of",
                values: {
                    totalPages: numberOfPages,
                },
            })}
            <button
                className={classNames(
                    "c-DocumentsPreviewer-Toolbar-pages-selection-button",
                    currentPage === 0 ? "disabled" : undefined
                )}
                onClick={() => onChangeCurrentPage(currentPage - 1)}
                disabled={currentPage === 0}
            >
                <FontAwesomeIcon icon={faChevronLeft as IconProp} />
            </button>
            <button
                className={classNames(
                    "c-DocumentsPreviewer-Toolbar-pages-selection-button",
                    currentPage === numberOfPages - 1 ? "disabled" : undefined
                )}
                onClick={() => onChangeCurrentPage(currentPage + 1)}
                disabled={currentPage === numberOfPages - 1}
            >
                <FontAwesomeIcon icon={faChevronRight as IconProp} />
            </button>
            <div className="c-DocumentsPreviewer-Toolbar-buttons-divider" />
            <button
                className={classNames(
                    "c-DocumentsPreviewer-Toolbar-pages-zoom-button",
                    scale <= 0.4 ? "disabled" : undefined
                )}
                onClick={() => onChangeScale(scale - 0.3)}
                disabled={scale <= 0.4}
            >
                <FontAwesomeIcon icon={faSearchMinus as IconProp} />
            </button>
            <button
                className="c-DocumentsPreviewer-Toolbar-pages-zoom-button"
                onClick={() => onChangeScale(scale + 0.3)}
            >
                <FontAwesomeIcon icon={faSearchPlus as IconProp} />
            </button>
        </div>
    );
};
